var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.667 4.394C11.667 5.26381 10.961 5.96975 10.0912 5.96975C9.22138 5.96975 8.51544 5.26381 8.51544 4.394C8.51544 3.52418 9.22138 2.81824 10.0912 2.81824C10.961 2.81824 11.667 3.52418 11.667 4.394ZM10.0911 8.33329C9.22132 8.33329 8.51538 9.03923 8.51538 9.90905C8.51538 10.7789 9.22132 11.4848 10.0911 11.4848C10.961 11.4848 11.6669 10.7789 11.6669 9.90905C11.6669 9.03923 10.961 8.33329 10.0911 8.33329ZM10.0911 13.8485C9.22132 13.8485 8.51538 14.5545 8.51538 15.4243C8.51538 16.2941 9.22132 17.0001 10.0911 17.0001C10.961 17.0001 11.6669 16.2941 11.6669 15.4243C11.6669 14.5545 10.961 13.8485 10.0911 13.8485Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4254_2201",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 2,
    width: 4,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.667 4.394C11.667 5.26381 10.961 5.96975 10.0912 5.96975C9.22138 5.96975 8.51544 5.26381 8.51544 4.394C8.51544 3.52418 9.22138 2.81824 10.0912 2.81824C10.961 2.81824 11.667 3.52418 11.667 4.394ZM10.0911 8.33329C9.22132 8.33329 8.51538 9.03923 8.51538 9.90905C8.51538 10.7789 9.22132 11.4848 10.0911 11.4848C10.961 11.4848 11.6669 10.7789 11.6669 9.90905C11.6669 9.03923 10.961 8.33329 10.0911 8.33329ZM10.0911 13.8485C9.22132 13.8485 8.51538 14.5545 8.51538 15.4243C8.51538 16.2941 9.22132 17.0001 10.0911 17.0001C10.961 17.0001 11.6669 16.2941 11.6669 15.4243C11.6669 14.5545 10.961 13.8485 10.0911 13.8485Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4254_2201)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVertical);
export default __webpack_public_path__ + "static/media/more-vertical.deac0782c04f2e10d9672242f88e53ca.svg";
export { ForwardRef as ReactComponent };